import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { notEmpty } from 'utils/ramdaAdditions';

const ApprovalLetter = ({ letter }) => notEmpty(letter) ? (
    <div>
        <DefinitionHeader translate='project.headers.message' iconType='comment' />
        <div className='panel-view'>
            <div dangerouslySetInnerHTML={{ __html: letter }} />
        </div>
    </div>
) : null;

export default ApprovalLetter;
